import { useLocation, useNavigate } from "react-router-dom";
import { Map, Trophy, Anvil, Swords, Book, User } from "lucide-react";

const NAV_ITEMS = [
  { id: "play", path: "/levels", icon: Map, label: "Play" },
  { id: "tournament", path: "/tournament", icon: Swords, label: "Arena" },
  { id: "ranks", path: "/leaderboard", icon: Trophy, label: "Ranks" },
  { id: "forge", path: "/crafting", icon: Anvil, label: "Forge" },
  { id: "codex", path: "/codex", icon: Book, label: "Codex" },
  { id: "profile", path: "/profile", icon: User, label: "Profile" },
];

export default function GameNavBar() {
  const location = useLocation();
  const navigate = useNavigate();

  // Don't show on game play pages
  if (location.pathname.startsWith("/play/")) return null;

  const activeId = NAV_ITEMS.find(
    (item) =>
      location.pathname === item.path ||
      (item.path === "/levels" && location.pathname === "/map")
  )?.id;

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-40 bg-slate-950/95 backdrop-blur-md border-t border-white/10 safe-area-bottom"
      data-testid="game-nav-bar"
    >
      <div className="flex items-center justify-around max-w-lg mx-auto h-14">
        {NAV_ITEMS.map((item) => {
          const isActive = item.id === activeId;
          const Icon = item.icon;
          return (
            <button
              key={item.id}
              onClick={() => navigate(item.path)}
              className={`flex flex-col items-center gap-0.5 px-2 py-1 rounded-lg transition-all ${
                isActive
                  ? "text-amber-400"
                  : "text-slate-500 hover:text-slate-300 active:scale-95"
              }`}
              data-testid={`nav-${item.id}`}
            >
              <Icon
                className={`w-5 h-5 transition-transform ${
                  isActive ? "scale-110" : ""
                }`}
              />
              <span
                className={`text-[10px] font-semibold ${
                  isActive ? "text-amber-400" : ""
                }`}
              >
                {item.label}
              </span>
              {isActive && (
                <span className="absolute -top-px left-1/2 -translate-x-1/2 w-6 h-0.5 bg-amber-400 rounded-full" />
              )}
            </button>
          );
        })}
      </div>
      <style>{`
        .safe-area-bottom { padding-bottom: env(safe-area-inset-bottom, 0px); }
      `}</style>
    </nav>
  );
}
